import React, { Component } from "react";
import DetailsTable from "../components/DetailsTable";
import DeleteButton from "../components/DeleteButton";
import DetailButton from "../components/DetailButton";
import TurnoverRow from "../components/TurnoverRow";
import { AgGridReact } from "ag-grid-react";
// import DatePicker from 'react-datepicker2';
import { Button, Image, Spinner } from "react-bootstrap";
import exportexcel from "../assets/exportexcel.png";
import turnovericon from "../assets/turnovericon.png";
import moment from "moment-jalaali";
import watermark from "../assets/watermark.png";
import firstpage from "../assets/firstpage.png";
import prepage from "../assets/prepage.png";
import nextpage from "../assets/nextpage.png";
import lastpage from "../assets/lastpage.png";
import { MagicSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

export default class Turnover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableIsFilter: false,
      pageSettings: { pageSize: 10 },
      filterOptions: { mode: "Immediate" },
      filterContainer: false,
      data: [],
      dataExist: false,
      isLoading: true,
      firstRowDate: null,
      lastRowDate: null,
      columnDefs: [
        {
          headerName: "",
          field: "linked_id",
          cellRenderer: "btnDetail",
          cellRendererParams: { detail: this.detailTransaction.bind(this) },
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
          maxWidth: 70,
        },
        {
          headerName: "تاریخ",
          field: "date",
          filter: false,
          resizable: true,
          sort: "desc",
          sortable: true,
          valueFormatter: this.formatContent,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "نوع",
          field: "type_lable",
          filter: false,
          resizable: true,
          sortable: true,
          valueFormatter: this.formatContent,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "سبد",
          field: "basket",
          filter: false,
          resizable: true,
          sortable: true,
          valueFormatter: this.formatContent,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "کارگزاری",
          field: "broker",
          filter: false,
          resizable: true,
          sortable: true,
          valueFormatter: this.formatContentBroker,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "نماد",
          field: "symbol",
          filter: false,
          resizable: true,
          sortable: true,
          valueFormatter: this.formatContent,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "تعداد",
          field: "quantity",
          filter: false,
          resizable: true,
          valueFormatter: this.numberWithCommasAB,
          sortable: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ",
          field: "cash_change",
          filter: false,
          valueFormatter: this.numberWithCommas,
          resizable: true,
          sortable: true,
          cellStyle: (params) =>
            ((params.data.type_id > 0 && params.data.type_id < 6) ||
              (params.data.type_id > 6 && params.data.type_id < 9) ||
              (params.data.type_id >= 12 && params.data.type_id <= 14)) &&
            params.value !== null &&
            params.value < 0
              ? {
                  color: "#ed2f59",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderStyle: "solid",
                  borderWidth: "0px 1px 0px 0px",
                  borderColor: "var(--gray6)",
                }
              : ((params.data.type_id > 0 && params.data.type_id < 6) ||
                  (params.data.type_id > 6 && params.data.type_id < 9) ||
                  (params.data.type_id >= 12 && params.data.type_id <= 14)) &&
                params.value !== null &&
                params.value > 0
              ? {
                  color: "#35d494",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderStyle: "solid",
                  borderWidth: "0px 1px 0px 0px",
                  borderColor: "var(--gray6)",
                }
              : {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderStyle: "solid",
                  borderWidth: "0px 1px 0px 0px",
                  borderColor: "var(--gray6)",
                },
          lockPosition: true,
        },
        {
          headerName: "زمان ثبت سند",
          field: "created_at",
          filter: false,
          resizable: true,
          sortable: true,
          valueFormatter: this.convertDate,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "btnDelete",
          cellRendererParams: {
            delete: this.deleteTransaction.bind(this),
            edit: this.editTransaction.bind(this),
          },
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
          minWidth: 60,
        },
        {
          headerName: "",
          field: "detail",
        },
      ],
      frameworkComponents: {
        btnDelete: DeleteButton,
        btnDetail: DetailButton,
      },
      dateValue: null,
      dateValue1: null,
      maxDate: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      maxDateStart: moment().add(-1, "days").format("jYYYY/jMM/jDD"),
      minDate: null,
      innerColumnDefs: [
        {
          headerName: "تاریخ",
          field: "date",
          filter: false,
          resizable: true,
          sort: "desc",
          sortable: true,
          valueFormatter: this.formatContent,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "نوع",
          field: "type_lable",
          filter: false,
          resizable: true,
          sortable: true,
          valueFormatter: this.formatContent,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "سبد",
          field: "basket",
          filter: false,
          resizable: true,
          sortable: true,
          valueFormatter: this.formatContent,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "کارگزاری",
          field: "broker",
          filter: false,
          resizable: true,
          sortable: true,
          valueFormatter: this.formatContentBroker,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "نماد",
          field: "symbol",
          filter: false,
          resizable: true,
          sortable: true,
          valueFormatter: this.formatContent,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "تعداد",
          field: "quantity",
          filter: false,
          resizable: true,
          valueFormatter: this.numberWithCommasAB,
          sortable: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 1px 0px 0px",
            borderColor: "var(--gray6)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ",
          field: "cash_change",
          filter: false,
          valueFormatter: this.numberWithCommasDetail,
          resizable: true,
          sortable: true,
          cellStyle: (params) =>
            params.value !== null && params.value < 0
              ? {
                  color: "#ed2f59",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderStyle: "solid",
                  borderWidth: "0px 1px 0px 0px",
                  borderColor: "var(--gray6)",
                }
              : params.value !== null && params.value > 0
              ? {
                  color: "#35d494",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderStyle: "solid",
                  borderWidth: "0px 1px 0px 0px",
                  borderColor: "var(--gray6)",
                }
              : {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderStyle: "solid",
                  borderWidth: "0px 1px 0px 0px",
                  borderColor: "var(--gray6)",
                },
          lockPosition: true,
        },
      ],
      innerRowData: [],
      currentBasketMode: null,
      currentBrokerId: 0,
      currentBaskets: 0,
      removeFilter: false,
      startDate: null,
      endDate: null,
      buttonDisabled: false,
      smallSizeData: [],
      smallSizeDataArray: [],
      currentPage: 1,
      lastPage: 1,
    };

    this.getTurnoverData = this.getTurnoverData.bind(this);
    this.prepareSmallSizeData = this.prepareSmallSizeData.bind(this);

    this.tableGrid = React.createRef();
    this.datepickerr1 = React.createRef();
    this.datepickerr = React.createRef();
  }

  deleteTransaction(value) {
    try {
      let data;
      this.state.data.forEach(function (entry) {
        if (entry.id === value && entry.detail === undefined) {
          data = entry;
        }
      });

      if (data.type_id === 6) {
        let dd = {
          mobile: localStorage.getItem("mobile"),
          token: localStorage.getItem("token"),
          basket_mod: "total",
          type_mod: "total",
          type: "",
          basket_list: 0,
          filters: ["linked_id='" + data.linked_id + "'"],
        };

        fetch("/api/getTransactionReport", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dd),
        })
          .then((res) => res.json())
          .then((resultt) => {
            if (resultt.status === 200) {
              data.child = resultt.result;
              this.props.deleteTransactionRequest(data);
            }
          })
          .catch((err) => {});
      } else {
        this.props.deleteTransactionRequest(data);
      }
    } catch (error) {
      this.props.history.push("/Login");
    }
  }

  editTransaction(value) {
    let data;
    this.state.data.forEach(function (entry) {
      if (entry.id === value) {
        data = entry;
      }
    });

    if (data.type_id === 6) {
      let dd = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        basket_mod: "total",
        type_mod: "total",
        type: "",
        basket_list: 0,
        filters: ["linked_id='" + data.linked_id + "'"],
      };

      fetch("/api/getTransactionReport", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dd),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            data.child = resultt.result;
            // console.log("resultt",data);
            this.props.edit(data);
          }
        })
        .catch((err) => {});
    } else {
      this.props.edit(data);
    }
  }

  detailTransaction(id) {
    try {
      let data;
      this.state.data.forEach(function (entry) {
        if (entry.linked_id === id) {
          data = entry;
        }
      });

      this.setState({ innerRowData: data.child });

      let temp = this.state.data.slice();

      let foundIndex = -1;

      let i = 0;
      temp.forEach(function (entry) {
        if (entry.detail === "table") {
          foundIndex = i;
        }
        i++;
      });

      if (foundIndex > -1) {
        let closeid = temp[foundIndex - 1].id;
        temp.splice(foundIndex, 1);

        if (data.id === closeid) {
          this.setState({ data: temp });
          return;
        }
      }
      let myIndex = temp.indexOf(data);
      let valuee = myIndex + 1;

      temp.splice(valuee, 0, {
        id: data.id,
        symbol: data.symbol,
        symbol_id: data.symbol_id,
        quantity: data.quantity,
        cash_change: data.cash_change,
        basket: data.basket,
        basket_id: data.basket_id,
        child: data.child,
        description: data.description,
        date: data.date,
        broker: data.broker,
        broker_id: data.broker_id,
        type_id: data.type_id,
        type_lable: data.type_lable,
        is_linked: data.is_linked,
        linked_id: data.linked_id,
        created_at: data.created_at,
        detail: "table",
        lable: data.lable,
      });

      this.setState({ data: temp });
    } catch (error) {}
  }

  GetDetailTransaction(id) {
    try {
      let data;
      this.state.data.forEach(function (entry) {
        if (entry.linked_id === id) {
          data = entry;
        }
      });
      return data.child;
    } catch (error) {}
  }

  detailWork(data, datachild) {
    try {
    } catch (error) {}
  }

  numberWithCommasDetail(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } catch (error) {
      return "-";
    }
  }

  numberWithCommas(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      if (params.data.type_id === 6 || params.data.type_id === 9) {
        return Math.abs(params.value)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    } catch (error) {
      return "-";
    }
  }

  numberWithCommasAB(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return Math.abs(params.value)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } catch (error) {
      return "-";
    }
  }

  formatContentBroker(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === "0" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      else {
        let result;
        if (
          params.data.lable !== "null" &&
          params.data.lable !== "" &&
          params.data.lable !== "0" &&
          params.data.lable !== 0 &&
          params.data.lable !== null
        ) {
          result = params.value + " (" + params.data.lable + ")";
        } else {
          result = params.value;
        }
        return result;
      }
    } catch (error) {
      return "-";
    }
  }

  formatContent(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === "0" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      else return params.value;
    } catch (error) {
      return "-";
    }
  }

  convertDate(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === "0" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      else {
        let timestamp = params.value;
        let index = timestamp.indexOf("T");
        let date = timestamp.substring(0, index);

        let h = new Date(params.value).toLocaleString("en-US", {
          timeZone: "Asia/Tehran",
          hour12: false,
        });
        let time = h.substring(h.indexOf(" "), h.length);
        if (time.substring(0, 3) === " 24")
          time = " 00" + time.substring(3, time.length);
        let newvalue = moment(date + time, "YYYY-MM-DD HH:mm:ss").format(
          "jYYYY/jMM/jDD HH:mm:ss"
        );
        console.log(date + time);
        return newvalue;
      }
    } catch (error) {
      return "-";
    }
  }

  convertDateToPersian(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  componentDidMount() {
    document.body.style.backgroundColor = "var(--white2)";
    this.props.pageIsopen();
    this.getTurnoverData(this.props.selectedBroker, this.props.selectedBasket);
  }

  componentDidUpdate(prevProps) {
    try {
      if (
        prevProps.pageWidth !== this.props.pageWidth &&
        this.props.pageWidth < 768 &&
        !this.state.smallSizeTable
      ) {
        this.setState({ smallSizeTable: true });
        this.prepareSmallSizeData();
      } else if (
        prevProps.pageWidth !== this.props.pageWidth &&
        this.props.pageWidth >= 768 &&
        this.state.smallSizeTable
      ) {
        this.setState({ smallSizeTable: false });
        this.tableGrid.current.api.paginationGoToPage(
          this.state.currentPage - 1
        );
        this.updatePagination();
      }
    } catch (error) {}
  }

  prepareSmallSizeData() {
    let tempData = this.state.data;
    tempData.sort(function (a, b) {
      return (
        Number(b.date.replace(/-/g, "")) - Number(a.date.replace(/-/g, ""))
      );
    });
    let totalPage = Math.ceil(tempData.length / 30);
    let dataArray = [];
    let a = 0;
    let b = 30;
    for (let i = 1; i <= totalPage; i++) {
      let slice = tempData.slice(a, b * i);
      dataArray.push(slice);
      a = b * i;
    }

    this.setState(
      { smallSizeDataArray: dataArray, lastPage: totalPage },
      () => {
        this.setState({
          smallSizeData:
            this.state.smallSizeDataArray[this.state.currentPage - 1],
        });
      }
    );
  }

  onGridReady() {
    try {
      this.updatePagination();

      var allColumnIds = [];
      this.tableGrid.current.columnApi
        .getAllColumns()
        .forEach(function (column) {
          allColumnIds.push(column.colId);
        });
      this.tableGrid.current.columnApi.autoSizeColumns(allColumnIds, false);
    } catch (error) {}
  }

  updatePagination() {
    try {
      if (this.props.pageWidth >= 768) {
        this.setState(
          {
            lastPage: this.tableGrid.current.api.paginationGetTotalPages(),
            currentPage:
              this.tableGrid.current.api.paginationGetCurrentPage() + 1,
          },
          () => {
            this.setState({
              paginationText:
                this.state.currentPage + " از " + this.state.lastPage,
            });
            if (this.state.lastPage === 1) {
              this.setState({
                firstPageDisable: true,
                prePageDisable: true,
                nextPageDisable: true,
                lastPageDisable: true,
              });
              return;
            }
            if (this.state.lastPage === 0) {
              this.setState({
                firstPageDisable: true,
                prePageDisable: true,
                nextPageDisable: true,
                lastPageDisable: true,
                paginationText: "1 از 1",
              });
              return;
            }

            if (this.state.currentPage === 1) {
              this.setState({
                firstPageDisable: true,
                prePageDisable: true,
                nextPageDisable: false,
                lastPageDisable: false,
              });
              return;
            }

            if (this.state.currentPage === this.state.lastPage) {
              this.setState({
                firstPageDisable: false,
                prePageDisable: false,
                nextPageDisable: true,
                lastPageDisable: true,
              });
              return;
            }

            if (this.state.currentPage > 1)
              this.setState({
                firstPageDisable: false,
                prePageDisable: false,
                nextPageDisable: false,
                lastPageDisable: false,
              });
          }
        );
      } else {
        this.setState({
          paginationText: this.state.currentPage + " از " + this.state.lastPage,
        });
        if (this.state.lastPage === 1) {
          this.setState({
            firstPageDisable: true,
            prePageDisable: true,
            nextPageDisable: true,
            lastPageDisable: true,
          });
          return;
        }
        if (this.state.lastPage === 0) {
          this.setState({
            firstPageDisable: true,
            prePageDisable: true,
            nextPageDisable: true,
            lastPageDisable: true,
            paginationText: "1 از 1",
          });
          return;
        }

        if (this.state.currentPage === 1) {
          this.setState({
            firstPageDisable: true,
            prePageDisable: true,
            nextPageDisable: false,
            lastPageDisable: false,
          });
          return;
        }

        if (this.state.currentPage === this.state.lastPage) {
          this.setState({
            firstPageDisable: false,
            prePageDisable: false,
            nextPageDisable: true,
            lastPageDisable: true,
          });
          return;
        }

        if (this.state.currentPage > 1)
          this.setState({
            firstPageDisable: false,
            prePageDisable: false,
            nextPageDisable: false,
            lastPageDisable: false,
          });
      }
    } catch (error) {}
  }

  firstPageClicked() {
    if (this.props.pageWidth >= 768) {
      this.tableGrid.current.api.paginationGoToFirstPage();
      this.updatePagination();
    } else {
      this.setState({ currentPage: 1 }, () => {
        this.setState({
          smallSizeData:
            this.state.smallSizeDataArray[this.state.currentPage - 1],
        });
        this.updatePagination();
      });
    }
  }

  prePageClicked() {
    if (this.props.pageWidth >= 768) {
      this.tableGrid.current.api.paginationGoToPreviousPage();
      this.updatePagination();
    } else {
      if (this.state.currentPage > 1) {
        this.setState({ currentPage: this.state.currentPage - 1 }, () => {
          this.setState({
            smallSizeData:
              this.state.smallSizeDataArray[this.state.currentPage - 1],
          });
          this.updatePagination();
        });
      }
    }
  }

  nextPageClicked() {
    if (this.props.pageWidth >= 768) {
      this.tableGrid.current.api.paginationGoToNextPage();
      this.updatePagination();
    } else {
      if (this.state.currentPage < this.state.lastPage) {
        this.setState({ currentPage: this.state.currentPage + 1 }, () => {
          this.setState({
            smallSizeData:
              this.state.smallSizeDataArray[this.state.currentPage - 1],
          });
          this.updatePagination();
        });
      }
    }
  }

  lastPageClicked() {
    if (this.props.pageWidth >= 768) {
      this.tableGrid.current.api.paginationGoToLastPage();
      this.updatePagination();
    } else {
      this.setState({ currentPage: this.state.lastPage }, () => {
        this.setState({
          smallSizeData:
            this.state.smallSizeDataArray[this.state.currentPage - 1],
        });
        this.updatePagination();
      });
    }
  }

  getTurnoverData(brokerId, baskets) {
    let data;
    let apiname;
    let basketmode = "";
    this.setState({ currentBrokerId: brokerId });

    if (brokerId === 0) {
      this.setState({ currentBrokerId: 0 });
      if (baskets === 0) {
        this.setState({ currentBasketMode: "total", currentBaskets: 0 });
        basketmode = "total";
      } else {
        this.setState({ currentBasketMode: "", currentBaskets: [baskets] });
        baskets = [baskets];
      }

      data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        basket_mod: basketmode,
        type_mod: "total",
        type: "",
        basket_list: baskets,
        filters: [],
      };

      apiname = "getTransactionReport";
    } else {
      data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        type_mod: "total",
        type: "",
        broker_id: brokerId,
        filters: [],
      };

      apiname = "getTransactionReportByBroker";
    }
    this.setState({ isLoading: true });
    fetch("/api/" + apiname, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        this.setState({ isLoading: false });
        console.log(resultt);
        if (resultt.status === 200) {
          this.setState(
            { data: this.getUnique(resultt.result), removeFilter: false },
            () => {
              if (this.state.data.length > 0) {
                this.prepareSmallSizeData();
                this.setState({ dataExist: true });
                let sDate = null;
                let eDate = null;
                this.state.data.forEach((element) => {
                  if (sDate === null || element.date < sDate)
                    sDate = element.date;
                  if (eDate === null || element.date > eDate)
                    eDate = element.date;
                });

                let d1 = moment(sDate, "jYYYY-jMM-jDD").format("jYYYY/jMM/jDD");
                let d2 = moment().format("jYYYY/jMM/jDD");

                // console.log("d1",d1);
                // console.log("d2",d2);
                // return
                // let d2=;
                this.setState({
                  dateValue1: d1,
                  firstRowDate: d1,
                  dateValue: d2,
                  lastRowDate: d2,
                  minDate: d1,
                });
              } else this.setState({ dataExist: false });
            }
          );
          this.updatePagination();
        } else {
          this.props.history.push("/Login");
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
      });
  }

  ExportExcel() {
    try {
      // let date1=this.convertDateToPersian(this.state.dateValue1)
      // let date2=this.convertDateToPersian(this.state.dateValue)

      let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );
      let date2 = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      let data;
      let apiname;

      if (this.state.currentBrokerId === 0) {
        let basket = [];
        if (this.state.currentBaskets !== 0)
          basket.push(this.state.currentBaskets);

        data = {
          mobile: localStorage.getItem("mobile"),
          token: localStorage.getItem("token"),
          basket_mod: this.state.currentBasketMode,
          type_mod: "total",
          type: "",
          basket_list: basket,
          filters: ["tr_date>='" + date1 + "' and tr_date<='" + date2 + "'"],
          toXls: true,
        };

        apiname = "getTransactionReport";
      } else {
        data = {
          mobile: localStorage.getItem("mobile"),
          token: localStorage.getItem("token"),
          type_mod: "total",
          type: "",
          broker_id: this.state.currentBrokerId,
          filters: ["tr_date>='" + date1 + "' and tr_date<='" + date2 + "'"],
          toXls: true,
        };

        apiname = "getTransactionReportByBroker";
      }
      this.setState({ buttonDisabled: true });
      fetch("/api/" + apiname, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.body)
        .then((stream) => new Response(stream))
        .then((response) => response.blob())
        .then((blob) => URL.createObjectURL(blob))
        .then((url) => {
          const link = document.createElement("a");
          link.href = url;
          link.download =
            "Turnover_" +
            date1 +
            "-" +
            date2 +
            "(" +
            this.props.selectedPortfolioName +
            ").xlsx";
          document.body.appendChild(link);
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          document.body.removeChild(link);
          this.setState({ buttonDisabled: false });
        })
        .catch((err) => {
          toast.error(err.message, {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ buttonDisabled: false });
        });
    } catch (error) {
      toast.error(error.message, {
        position: toast.POSITION.BOTTOM_LEFT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      this.setState({ buttonDisabled: false });
    }
  }

  getUnique(array) {
    let uniqueArray = [];
    let a = [];
    let i = 0;

    array.forEach(function (entry) {
      if (entry.linked_id !== null) {
        let found = false;
        a.forEach((element) => {
          if (element.linked_id === entry.linked_id) {
            found = true;
            let child = uniqueArray[element.index].child;
            child.push(entry);
            uniqueArray[element.index].child = child;
          }
        });

        if (!found) {
          let en = {};
          Object.assign(en, entry);
          let child = [];
          child.push(en);
          entry.child = child;
          uniqueArray.push(entry);
          let obj = { linked_id: entry.linked_id, index: i };
          a.push(obj);
          i++;
        }
      } else {
        uniqueArray.push(entry);
        i++;
      }
    });

    uniqueArray.forEach((element) => {
      if (
        element.linked_id !== null &&
        element.type_id !== 6 &&
        element.type_id !== 9
      ) {
        element.child.forEach((element1) => {
          if (
            element1.type_id === 6 ||
            (element1.type_id === 9 && element1.quantity < 0)
          ) {
            Object.assign(element, element1);
          }
        });
      } else if (element.linked_id !== null && element.type_id === 9) {
        element.child.forEach((element1) => {
          if (element1.quantity < 0) {
            Object.assign(element, element1);
          }
        });
      }
    });

    return uniqueArray;
  }

  exportExcelInDone() {
    this.setState({ buttonDisabled: false });
  }

  filterClicked() {
    if (this.state.filterContainer) {
      this.setState({ filterContainer: false });
    } else {
      this.setState({ filterContainer: true });
    }
  }

  fileterByDate() {
    try {
      // let date1=this.convertDateToPersian(this.state.dateValue1)
      // let date2=this.convertDateToPersian(this.state.dateValue)

      let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );
      let date2 = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      let data;
      let apiname;

      if (this.state.currentBrokerId === 0) {
        let basket = [];
        if (this.state.currentBaskets !== 0)
          basket.push(this.state.currentBaskets);

        data = {
          mobile: localStorage.getItem("mobile"),
          token: localStorage.getItem("token"),
          basket_mod: this.state.currentBasketMode,
          type_mod: "total",
          type: "",
          basket_list: basket,
          filters: ["tr_date>='" + date1 + "' and tr_date<='" + date2 + "'"],
        };

        apiname = "getTransactionReport";
      } else {
        data = {
          mobile: localStorage.getItem("mobile"),
          token: localStorage.getItem("token"),
          type_mod: "total",
          type: "",
          broker_id: this.state.currentBrokerId,
          filters: ["tr_date>='" + date1 + "' and tr_date<='" + date2 + "'"],
        };

        apiname = "getTransactionReportByBroker";
      }
      this.setState({ isLoading: true });
      fetch("/api/" + apiname, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.setState({ dataExist: true });
            this.setState({ data: this.getUnique(resultt.result) }, () => {
              if (this.state.data.length > 30) {
                this.prepareSmallSizeData();
              } else {
              }
              this.updatePagination();
              this.setState({ isLoading: false });
              if (
                this.state.dateValue1 === this.state.firstRowDate &&
                this.state.dateValue === this.state.lastRowDate
              )
                this.setState({ removeFilter: false });
              else this.setState({ removeFilter: true });
            });
          } else {
            this.props.history.push("/Login");
          }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
        });
    } catch (error) {}
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange(dateValue) {
    try {
      this.datepickerr.current.closeCalendar();
      this.datepickerr1.current.closeCalendar();
    } catch (error) {}
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));

    this.setState({ dateValue: value, maxDateStart: value });
  }

  dateChange1(dateValue) {
    try {
      this.datepickerr.current.closeCalendar();
      this.datepickerr1.current.closeCalendar();
    } catch (error) {}
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    let min = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    // console.log("min",min);
    this.setState({ dateValue1: value, minDate: min });

    // this.setState({ dateValue1: dateValue,minDate:moment(dateValue).add(0,'days')})
  }

  accordionOpenBuySell() {
    this.props.accordionOpen("buysell");
  }

  accordionOpenInOut() {
    this.props.accordionOpen("inout");
  }

  doesExternalFilterPass(node) {
    return node.data.date === "1399-06-04";
  }

  removeFilter() {
    this.getTurnoverData(this.state.currentBrokerId, this.state.currentBaskets);
  }

  accordionOpenExcel() {
    this.props.accordionOpen("excel");
  }

  render() {
    return (
      <div
        ref={this.tabcontainer}
        className={
          this.props.tabselectedindex === 0
            ? "tabsContainer rmvStartRadius"
            : "tabsContainer"
        }
      >
        <div ref={this.tabcontent} className="tabsContent tabsContentMax">
          {this.props.pageWidth >= 750 && (
            <div ref={this.container} className="tabsContentHeader">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "12px",
                  color: "var(--gray4)",
                }}
              >
                <img
                  src={turnovericon}
                  style={{ height: "20px", marginLeft: "10px" }}
                  alt="turnover"
                />
                <div>گردش حساب</div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  alignItems: "center",
                  flexWrap: "wrap",
                  flex: "1",
                }}
              >
                <Button
                  variant="secondary"
                  className="filterButton"
                  disabled={this.state.buttonDisabled}
                  onClick={this.ExportExcel.bind(this)}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {this.state.buttonDisabled && (
                      <Spinner className="spinnerStyle" animation="border" />
                    )}
                    {!this.state.buttonDisabled && (
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <div
                          style={{
                            marginLeft: "10px",
                            height: "100%",
                            paddingTop: "4px",
                          }}
                        >
                          فایل اکسل
                        </div>
                        <Image style={{ height: "16px" }} src={exportexcel} />
                      </div>
                    )}
                  </div>
                </Button>
                <div
                  style={{
                    flexWrap: "wrap",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    fontSize: "12px",
                  }}
                >
                  {!this.state.showTable && (
                    <div
                      style={{
                        margin: "0px 10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ margin: "0px 5px", whiteSpace: "nowrap" }}>
                        شروع بازه:
                      </div>
                      <DatePicker
                        ref={this.datepickerr1}
                        value={this.state.dateValue1}
                        inputClass="form-control inputStyleFilter"
                        calendar="persian"
                        locale="fa"
                        weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                        format="YYYY/MM/DD"
                        animation
                        className="bluee"
                        onChange={(valuee) => this.dateChange1(valuee)}
                        maxDate={this.state.maxDateStart}
                        editable={false}
                        inputMode="none"
                        placeholder="شروع"
                      />
                    </div>
                  )}

                  <div
                    style={{
                      margin: "0px 10px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {!this.state.showTable && (
                      <div style={{ margin: "0px 5px", whiteSpace: "nowrap" }}>
                        پایان بازه:
                      </div>
                    )}
                    {this.state.showTable && (
                      <div style={{ margin: "0px 5px", whiteSpace: "nowrap" }}>
                        تاریخ:
                      </div>
                    )}
                    <DatePicker
                      ref={this.datepickerr}
                      value={this.state.dateValue}
                      inputClass="form-control inputStyleFilter"
                      calendar="persian"
                      locale="fa"
                      weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                      format="YYYY/MM/DD"
                      animation
                      className="bluee"
                      onChange={(valuee) => this.dateChange(valuee)}
                      minDate={this.state.minDate}
                      maxDate={this.state.maxDate}
                      editable={false}
                      inputMode="none"
                      placeholder="پایان"
                    />
                  </div>
                  {!this.state.showTable && (
                    <Button
                      onClick={this.fileterByDate.bind(this)}
                      disabled={
                        this.state.dateValue !== null &&
                        this.state.dateValue1 !== null
                          ? false
                          : true
                      }
                      style={{
                        padding: "0px 10px",
                        fontSize: "10px",
                        marginLeft: "10px",
                        height: "32px",
                        whiteSpace: "nowrap",
                        color: "white",
                      }}
                    >
                      اعمال فیلتر
                    </Button>
                  )}
                  {this.state.removeFilter && (
                    <Button
                      variant="danger"
                      onClick={this.removeFilter.bind(this)}
                      style={{
                        padding: "0px 5px",
                        fontSize: "10px",
                        marginRight: "5px",
                        height: "32px",
                        whiteSpace: "nowrap",
                        color: "white",
                      }}
                    >
                      حذف فیلتر
                    </Button>
                  )}
                </div>
              </div>
            </div>
          )}
          {this.props.pageWidth < 750 && (
            <div ref={this.container} className="tabsContentHeaderSmall">
              <div className="tabsContentHeaderChild1">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "var(--gray4)",
                  }}
                >
                  <img
                    src={turnovericon}
                    style={{ height: "20px", marginLeft: "10px" }}
                    alt="turnover"
                  />
                  <div>گردش حساب</div>
                </div>
                <Button
                  variant="secondary"
                  className="filterButton"
                  disabled={this.state.buttonDisabled}
                  onClick={this.ExportExcel.bind(this)}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {this.state.buttonDisabled && (
                      <Spinner className="spinnerStyle" animation="border" />
                    )}
                    {!this.state.buttonDisabled && (
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <Image style={{ height: "16px" }} src={exportexcel} />
                      </div>
                    )}
                  </div>
                </Button>
              </div>
              <div
                className="tabsContentHeaderChild2"
                style={{ flexDirection: "row-reverse" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  {!this.state.showTable && (
                    <div
                      style={{
                        margin: "0px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          marginRight: "0px",
                          marginLeft: "3px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        شروع:
                      </div>
                      {/* <DatePicker
                                                max={this.state.maxDateStart}
                                                className="form-control inputStyleFilter"
                                                timePicker={false}
                                                isGregorian={false}
                                                ref={(scope) => this.datepickerr1 = scope}
                                                onChange={valuee => this.dateChange1(valuee)}
                                                value={this.state.dateValue1}/> */}
                      <DatePicker
                        ref={this.datepickerr1}
                        value={this.state.dateValue1}
                        inputClass="form-control inputStyleFilter"
                        calendar="persian"
                        locale="fa"
                        weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                        format="YYYY/MM/DD"
                        animation
                        className="rmdp-mobile bluee"
                        onChange={(valuee) => this.dateChange1(valuee)}
                        maxDate={this.state.maxDateStart}
                        editable={false}
                        inputMode="none"
                        placeholder="شروع"
                      />
                    </div>
                  )}

                  <div
                    style={{
                      margin: "0px 5px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {!this.state.showTable && (
                      <div style={{ margin: "0px 3px", whiteSpace: "nowrap" }}>
                        پایان:
                      </div>
                    )}
                    {this.state.showTable && (
                      <div style={{ margin: "0px 3px", whiteSpace: "nowrap" }}>
                        تاریخ:
                      </div>
                    )}
                    {/* <DatePicker
                                                min={this.state.minDate}
                                                max={this.state.maxDate}
                                                className="form-control inputStyleFilter"
                                                timePicker={false}
                                                isGregorian={false}
                                                ref={(scope) => this.datepickerr = scope}
                                                onChange={valuee => this.dateChange(valuee)}
                                                value={this.state.dateValue}
                                            /> */}
                    <DatePicker
                      ref={this.datepickerr}
                      value={this.state.dateValue}
                      inputClass="form-control inputStyleFilter"
                      calendar="persian"
                      locale="fa"
                      weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                      format="YYYY/MM/DD"
                      animation
                      className="rmdp-mobile bluee"
                      onChange={(valuee) => this.dateChange(valuee)}
                      minDate={this.state.minDate}
                      maxDate={this.state.maxDate}
                      editable={false}
                      inputMode="none"
                      placeholder="پایان"
                    />
                  </div>
                  {!this.state.showTable && (
                    <Button
                      onClick={this.fileterByDate.bind(this)}
                      disabled={
                        this.state.dateValue !== null &&
                        this.state.dateValue1 !== null
                          ? false
                          : true
                      }
                      style={{
                        padding: "0px 5px",
                        fontSize: "10px",
                        height: "32px",
                        whiteSpace: "nowrap",
                        color: "white",
                      }}
                    >
                      اعمال
                    </Button>
                  )}
                  {this.state.removeFilter && (
                    <Button
                      variant="danger"
                      onClick={this.removeFilter.bind(this)}
                      style={{
                        padding: "0px 5px",
                        fontSize: "10px",
                        marginRight: "5px",
                        height: "32px",
                        whiteSpace: "nowrap",
                        color: "white",
                      }}
                    >
                      حذف
                    </Button>
                  )}
                </div>
              </div>
            </div>
          )}
          {this.state.dataExist && (
            <div
              className="ag-theme-alpine"
              style={{
                direction: "rtl",
                width: "100%",
                flex: "1",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                overflow: "auto",
              }}
            >
              {this.props.pageWidth >= 768 && !this.state.isLoading && (
                <AgGridReact
                  enableRtl={true}
                  autoHeight={true}
                  animateRows={true}
                  suppressSizeToFit={true}
                  columnDefs={this.state.columnDefs}
                  localeText={this.props.gridLocaleText}
                  rowData={this.state.data}
                  suppressDragLeaveHidesColumns={true}
                  suppressMovable={true}
                  onGridReady={this.onGridReady.bind(this)}
                  multiSortKey="ctrl"
                  frameworkComponents={this.state.frameworkComponents}
                  rowHeight={24}
                  headerHeight={35}
                  pagination={true}
                  paginationPageSize={30}
                  suppressPaginationPanel={true}
                  isFullWidthCell={(node) => {
                    return node.data.detail === "table";
                  }}
                  fullWidthCellRendererFramework={(param) => {
                    if (param.data.detail === "table")
                      return (
                        <DetailsTable
                          data={this.state.innerRowData}
                          columnDefs={this.state.innerColumnDefs}
                          gridLocaleText={this.props.gridLocaleText}
                        />
                      );
                  }}
                  getRowHeight={(param) => {
                    if (param.data.detail === "table") return 150;
                  }}
                  ref={this.tableGrid}
                ></AgGridReact>
              )}

              {this.props.pageWidth < 768 &&
                !this.state.isLoading &&
                this.state.smallSizeData !== undefined && (
                  <div
                    className="portfolioContainer"
                    style={{ paddingLeft: "3px", paddingRight: "2px" }}
                  >
                    {this.state.smallSizeData.map((item, i) => (
                      <TurnoverRow
                        editItem={this.editTransaction.bind(this)}
                        deleteItem={this.deleteTransaction.bind(this)}
                        hasChild={
                          item.child !== undefined && item.child.length > 0
                            ? true
                            : false
                        }
                        GetDetailTransaction={this.GetDetailTransaction.bind(
                          this
                        )}
                        key={i}
                        type_id={item.type_id}
                        id={item.id}
                        symbol={item.symbol}
                        quantity={item.quantity}
                        date={item.date}
                        type_lable={item.type_lable}
                        basket={item.basket}
                        broker={item.broker}
                        cash_change={item.cash_change}
                        created_at={item.created_at}
                        linked_id={item.linked_id}
                      />
                    ))}
                  </div>
                )}
              {this.state.isLoading && (
                <div className="loading-inside">
                  <MagicSpinner
                    size={70}
                    color="var(--green1)"
                    loading={true}
                  />
                  <div style={{ marginTop: "14px" }}>لطفاً شکیبا باشید</div>
                </div>
              )}
            </div>
          )}
          {this.state.dataExist && !this.state.isLoading && (
            <div className="tablePaginationContainer">
              <div className="paginationDiv">
                <Button
                  variant="secondary"
                  disabled={this.state.firstPageDisable}
                  className="paginationButton"
                  onClick={this.firstPageClicked.bind(this)}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img style={{ height: "14px" }} src={prepage} alt="" />
                  </div>
                </Button>
                <Button
                  variant="secondary"
                  disabled={this.state.prePageDisable}
                  className="paginationButton"
                  onClick={this.prePageClicked.bind(this)}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img style={{ height: "14px" }} src={firstpage} alt="" />
                  </div>
                </Button>
                <div style={{ margin: "0px 10px" }}>
                  {this.state.paginationText}
                </div>
                <Button
                  variant="secondary"
                  disabled={this.state.nextPageDisable}
                  className="paginationButton"
                  onClick={this.nextPageClicked.bind(this)}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img style={{ height: "14px" }} src={lastpage} alt="" />
                  </div>
                </Button>
                <Button
                  variant="secondary"
                  disabled={this.state.lastPageDisable}
                  className="paginationButton"
                  onClick={this.lastPageClicked.bind(this)}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img style={{ height: "14px" }} src={nextpage} alt="" />
                  </div>
                </Button>
              </div>
            </div>
          )}
          {!this.state.dataExist && !this.state.isLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: "1",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                color: "var(--gray4)",
              }}
            >
              {/* <img src={watermark} alt="watermark" style={{marginBottom:'20px'}}/>
                            سبد خالی است
                            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'350px',marginTop:'20px'}}>
                                <Button onClick={this.accordionOpenInOut.bind(this)} style={{padding:'0px 25px',fontSize:'12px',marginLeft:'10px',height:'30px',whiteSpace: 'nowrap',color:'white'}}>ثبت واریز و برداشت جدید</Button>
                                <Button onClick={this.accordionOpenBuySell.bind(this)} style={{padding:'0px 25px',fontSize:'12px',marginLeft:'10px',height:'30px',whiteSpace: 'nowrap',color:'white'}}>ثبت خرید و فروش جدید</Button>
                            </div>
                            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',minWidth:'100px',width:'fit-content',maxWidth:'350px',marginTop:'20px',minHeight:'32px'}}>
                                <Button variant="secondary" onClick={this.accordionOpenExcel.bind(this)} className="nothingButton">ورود اطلاعات اکسل</Button>
                            </div> */}
              <img
                src={watermark}
                alt="watermark"
                style={{
                  marginBottom: "20px",
                  width: "70%",
                  maxWidth: "350px",
                  minWidth: "100px",
                }}
              />
              سبد خالی است
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  minWidth: "100px",
                  width: "fit-content",
                  maxWidth: "350px",
                  marginTop: "20px",
                  minHeight: "32px",
                }}
              >
                <Button
                  onClick={this.accordionOpenInOut.bind(this)}
                  className="nothingButton"
                  style={{ marginRight: "0" }}
                >
                  ثبت واریز و برداشت جدید
                </Button>
                <Button
                  onClick={this.accordionOpenBuySell.bind(this)}
                  className="nothingButton"
                  style={{ marginLeft: "0" }}
                >
                  ثبت خرید و فروش جدید
                </Button>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  minWidth: "100px",
                  width: "fit-content",
                  maxWidth: "350px",
                  marginTop: "20px",
                  minHeight: "32px",
                }}
              >
                <Button
                  variant="secondary"
                  onClick={this.accordionOpenExcel.bind(this)}
                  className="nothingButton"
                >
                  ورود اطلاعات اکسل
                </Button>
              </div>
            </div>
          )}

          {!this.state.dataExist && this.state.isLoading && (
            <div className="loading-inside">
              <MagicSpinner size={70} color="var(--green1)" loading={true} />
              <div style={{ marginTop: "14px" }}>لطفاً شکیبا باشید</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
